import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ColumnControllerAiColumnGetParams } from '@/apis/swaggers/v3/api/reservation/reservation-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ColumnControllerAiColumnGetParams, unknown>

const fetchAiReservationColumn = async (params: ColumnControllerAiColumnGetParams) => {
  const { data } = await apiClient.v3.columnControllerAiColumnGet(params);
  return checkApiResponse(data);
}

export const reservationColumnAiKeys = {
  all: [QUERY_KEY.columnControllerAiColumnGet] as const,
  list: (params: ColumnControllerAiColumnGetParams) => [...reservationColumnAiKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(reservationColumnAiFindQueryOptions(params))` */
export const reservationColumnAiFindQueryOptions = (params: ColumnControllerAiColumnGetParams) => ({
  queryKey: reservationColumnAiKeys.list(params),
  queryFn: () => fetchAiReservationColumn(params),
})

export const useReservationColumnAiFindQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: reservationColumnAiKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchAiReservationColumn(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
